module.exports = __webpack_public_path__ + "img/decorate.1725861f.png";